import React from 'react';

import PropTypes from 'prop-types';

import '../../utils/styles/Home.css';
import Photo from '../../assets/home.jpg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faTv,
    faGraduationCap,
    faCalendarDay,
    faEnvelope,
    faGlobe,
} from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons';

import NewsCarousel from '../../components/News/NewsCarousel';

/**
 * A reusable component to render a link with an icon and label.
 *
 * @param {string} href - The URL to link to.
 * @param {object} icon - The FontAwesome icon to display.
 * @param {string} label - The label text to display next to the icon.
 * @param {string} className - The custom class name to apply to the link.
 * @returns {JSX.Element} A link with an icon and label.
 */
function LinkItem({ href, icon, label, className }) {
    return (
        <a href={href}>
            <div className={`link ${className}`}>
                <FontAwesomeIcon icon={icon} size="xl" />
            </div>
            <span>{label}</span>
        </a>
    );
}

LinkItem.propTypes = {
    href: PropTypes.string.isRequired,
    icon: PropTypes.object.isRequired,
    label: PropTypes.string.isRequired,
    className: PropTypes.string,
};

/**
 * A reusable component to render a social media link with an icon and label.
 *
 * @param {string} href - The URL to link to.
 * @param {object} icon - The FontAwesome icon to display.
 * @param {string} label - The label text to display next to the icon.
 * @returns {JSX.Element} A social media link with an icon and label.
 */
function SocialLink({ href, icon, label }) {
    return (
        <a href={href}>
            <FontAwesomeIcon icon={icon} size="xl" />
            <span>{label}</span>
        </a>
    );
}

SocialLink.propTypes = {
    href: PropTypes.string.isRequired,
    icon: PropTypes.object.isRequired,
    label: PropTypes.string.isRequired,
};

/**
 * The main content component of the homepage, displaying various sections
 * such as links, news carousel, social media links, and information about
 * the AGE application.
 *
 * @returns {JSX.Element} The homepage content with links, news, and social media.
 */
function Home() {
    return (
        <>
            <div id="home-img">
                <img src={Photo} alt="Namur" />
                <p id="home-title" className="title-2">
                    Assemblée Générale des Étudiant·es
                </p>
            </div>

            <div className="container">
                <div id="link-campus">
                    <LinkItem
                        href="https://bve.unamur.be/"
                        icon={faTv}
                        label="BVE"
                        className="link1"
                    />
                    <LinkItem
                        href="https://webcampus.unamur.be"
                        icon={faGraduationCap}
                        label="WebCampus"
                        className="link2"
                    />
                    <LinkItem
                        href="https://horaires.unamur.be"
                        icon={faCalendarDay}
                        label="ADE"
                        className="link3"
                    />
                </div>

                <div>
                    <p className="title">À la une</p>
                    <NewsCarousel />
                </div>

                <div id="home-info">
                    <p className="title">De retour</p>
                    <p>
                        L'application AGE est de retour avec de nouvelles
                        fonctionnalités pour vous aider à mieux appréhender
                        votre vie étudiante sur le campus. Alors, profitez-en
                        sans modération !
                    </p>
                </div>

                <div id="home-social-networks">
                    <p className="title">Retrouvez nous</p>
                    <div className="links-sn">
                        <SocialLink
                            href="https://www.facebook.com/agenamur/"
                            icon={faFacebook}
                            label="Facebook"
                        />
                        <SocialLink
                            href="https://www.instagram.com/age_unamur/"
                            icon={faInstagram}
                            label="Instagram"
                        />
                        <SocialLink
                            href="https://www.age-namur.be/"
                            icon={faGlobe}
                            label="Internet"
                        />
                        <SocialLink
                            href="mailto:age@unamur.be"
                            icon={faEnvelope}
                            label="Mail"
                        />
                    </div>
                </div>
            </div>
        </>
    );
}

export default Home;
